import { render, staticRenderFns } from "./LicenseCheckJxshop.vue?vue&type=template&id=580cd3be&scoped=true&"
import script from "./LicenseCheckJxshop.vue?vue&type=script&lang=js&"
export * from "./LicenseCheckJxshop.vue?vue&type=script&lang=js&"
import style0 from "./LicenseCheckJxshop.vue?vue&type=style&index=0&id=580cd3be&scoped=true&lang=css&"
import style1 from "./LicenseCheckJxshop.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580cd3be",
  null
  
)

export default component.exports